import React, { useMemo, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import "./DashboardRegulatedScatter.scss";
import RegulatedScatterChart from "../DataEstate/DataEstateCards/RegulatedScatterChart";
import { REGULATED_COLOR_PALETTE } from "../DataTagConstants";


const INACTIVE_COLOR = "#9ca3af";

export default function DashboardRegulatedScatter({
  data,
  expanded = false,
  onClose,
}) {
  const [activeFilter, setActiveFilter] = useState(null);


  const filters = useMemo(() => {
    const set = new Set();

    Object.keys(data || {}).forEach((k) =>
      k.split(",").forEach((c) => set.add(c.trim())),
    );

    return Array.from(set).sort((a, b) => a.localeCompare(b));
  }, [data]);

  const classificationColors = useMemo(() => {
    return filters.reduce((acc, classification, index) => {
      acc[classification] = REGULATED_COLOR_PALETTE[index % REGULATED_COLOR_PALETTE.length];

      return acc;
    }, {});
  }, [filters]);

  const toggleFilter = (type) => {
    setActiveFilter((prev) => (prev === type ? null : type));
  };

  return (
    <div className={`dashboard-regulated ${expanded ? "is-expanded" : ""}`}>
      <div className="dr-content">
        <RegulatedScatterChart
          data={data}
          expanded={expanded}
          activeFilter={activeFilter}
        />

        <div className="ss-filters">
          {filters.map((type) => {
            const active = activeFilter === type;
            return (
              <div
                key={type}
                className={`ss-filter ${active ? "active" : ""}`}
                style={{ "--filter-color": classificationColors[type] }}
                onClick={() => toggleFilter(type)}
              >
                {type}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
